import type { ComponentProps } from "react"

export default function PropertyHotel(
  props: ComponentProps<"svg"> & { fill?: string },
) {
  const { fill = "currentColor", ...svgProps } = props

  return (
    <svg
      width="32"
      height="32"
      viewBox="0 0 32 32"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...svgProps}
    >
      <path
        d="M26.6666 19.0507V8H24V10.6667H7.99996V8H5.33329V19.0507C4.43332 19.3351 3.54385 19.6517 2.66663 20V29.3333H5.33329V26.6667H26.6666V29.3333H29.3333V20C28.444 19.644 27.556 19.3333 26.6666 19.0507ZM24 13.3333V18.3C21.8136 17.7718 19.5807 17.4592 17.3333 17.3667V13.3333H24ZM7.99996 13.3333H14.6666V17.3667C12.4192 17.4592 10.1863 17.7718 7.99996 18.3V13.3333ZM5.33329 24V22.6667H26.6666V24H5.33329Z"
        fill={fill}
      />
    </svg>
  )
}
